define('views/modules/calendar/nutrition/entry/food-entry-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // services
    'services/user',
    'services/viewport',
    // collections
    'models/calendar/nutrition/entry',
    'models/calendar/nutrition/food',
    // interface
    'views/modules/calendar/nutrition/entry/food-receptor-interface',
    // views
    'views/parts/list/list',
    'views/modules/calendar/nutrition/entry/food-entry-list-item',
    'views/modules/calendar/nutrition/entry/suggestion-item',
    'views/parts/modal/image-modal',
    'src/file-upload-model',
    // templates
    'text!templates/modules/calendar/nutrition/entry/food-entry-list.html',
], function(
    // Libs
    _, Backbone, Mustache, moment, U,
    // services
    User,
    Viewport,
    // collections
    MFoodEntry,
    MFood,
    // interface
    FoodReceptorInterface,
    // views
    VList,
    VFoodEntryListItem,
    VFoodEntrySuggestionItem,
    VImageModal,
    FileUploadModel,
    // templates
    TFoodEntryList
) {

    var VFoodEntryList = VList.extend(_.extend({}, FoodReceptorInterface, {
        template: TFoodEntryList,
        className: "nutrition-section",
        events: {
            "click .food-add-item": "onAddClick",
            "drag:enter .list-items": "onDragEnter",
            "drag:leave .list-items": "onDragLeave",
            "click #food-photo-edit": "onPhotoClick"
        },
        regions: {
            list: '.list-items',
            photo: "#food-photo-upload",
        },
        sortable: {
            group: {
                name: 'food-entry',
                pull: true,
                put: ['food-entry', 'food-item']
            },
            sort: false,
            item: '.food-list-item',
            filter: '.icon-section',
            delay: Viewport.width() <= 768 ? 50 : 0,
            // handle: '.food-name',
            dragoverBubble: true,
            // callbacks
            onAdd: 'onDragAdd',
            onSort: 'onDragSort',
            onEnd: 'onDragEnd',
        },

        initialize: function(opt) {
            this.options = _.extend({
                prepend: true,
                async: false,
                foodCheck: true,
                caller: 'nutrition'
            }, opt);

            this.viewModel = new Backbone.Model({ calories: 0, totalCalories: 0 });

            this.uploadModel = new FileUploadModel({
                urlRoot: 'nutrition/meal/',
                files: ['photo']
            });

            this.view = {}

            // listeners
            this.listenTo(this.collection, {
                'entry:remove': this.onEntryRemove,
                'entry:add': this.onEntryAdd,
                'entry:move': this.onEntryMove,
                'reset update change': this.onCollectionChange
            });
        },

        render: function() {
            this.undelegateEvents();
            VFoodEntryList.__super__.render.apply(this, arguments);
            this.delegateEvents();
            return this;
        },

        item: function(options) {
            var model = (options || {}).model;
            // if (!options.hasOwnProperty('foodCheck'))
            //     options.foodCheck = false;

            if (model && model.isSuggestion()) {
                return new VFoodEntrySuggestionItem(options);
            }
            return new VFoodEntryListItem(options);
        },

        /**
         * Create a model and view from an existing element.
         * @param {DOMElement} el existing element to use.
         * @param {Object} food attributes to make a model from.
         */
        _addEntry: function(entry, el, position) {
            var createView = Boolean(el);
            // if (this.options.caller === 'recipe') {
            //     createView = true;
            //     this.options.foodCheck = false;
            // }

            var newEntry = this.collection.add(entry, { silent: createView, at: position });
            var newView = createView && new this.item({ el: el, model: newEntry, foodCheck: this.options.foodCheck });

            // if (this.options.caller === 'recipe') {
            //     newView.options.foodCheck = false;
            // }

            newEntry.enteredBy(User.isSupervisor ? 'supervisor' : 'member');
            if (this.options.date && this.model.hasPassed()) newEntry.isEaten(true);

            if (createView) this.childViews.push(newView.render());

            this.collection.trigger('entry:add', newEntry, position);

            /*
            var createView = Boolean(el);
            var silentevent = this.options.collectionSilent === true ? true : createView;
            var newEntry = this.collection.add(entry, { silent: silentevent });
            var newView = (createView || this.options.collectionSilent) && new this.item({ el: el, model: newEntry, foodCheck: this.options.foodCheck });

            newEntry.enteredBy(User.isSupervisor ? 'supervisor' : 'member');
            if (this.options.date && this.model.hasPassed()) newEntry.isEaten(true);

            if (createView || this.options.collectionSilent) this.childViews.push(newView.render());

            this.collection.trigger('entry:add', newEntry);
            */
        },

        addEntry: function(model, view, position) {
            var el = view && view.el,
                entry = new MFoodEntry(model.tag ? model : { _food: this.getModelFoods(model) }),
                food = entry.getFood();

            if (entry.hasFood()) {
                food.fetch({
                    context: this,
                    success: function() { this._addEntry(entry, el, position); }
                });
            } else {
                this._addEntry(entry, el, position);
            }
        },

        getModelFoods: function(model) {
          return model.collection ? model.attributes : model;
        },

        refreshCalories: function() {
            this.viewModel.set('calories', this.collection.getCalories());
            this.viewModel.set('totalCalories', this.collection.getTotalCalories());
        },

        toggleChosen: function(value) {
            this.$el.toggleClass('chosen', value);
        },

        showPhotoModal: function() {
            var view = this.view.modal;
            if (!view) {
                this.view.modal = new VImageModal({
                    title: "calendar:Add a picture for this meal",
                    context: this,
                    callback: this.onPhotoChange,
                    // Pass images for the corresponding hour to display them in the modal
                    galleryImages: this.filterPhotos()
                });
            }
            this.view.modal.show();
        },

        filterPhotos: function() {
            var photos = this.model.get('photos');
            if(!photos || photos.length == 0) {
                return [];
            }

            return photos.filter(function(photo) {
                return photo.hour == this.options.hour;
            }, this)
        },

        setPhotoPreview: function(blob) {
            var photoUrl = URL.createObjectURL(blob),
                $photo = this.zone.$photo;
            $photo.attr('src', photoUrl);
        },

        // Upload the image on the server when the modal closes
        setPhotoFile: function(blob, hour) {
            this.uploadModel.set('photo', blob);
            this.uploadModel.set('hour', hour);

            this.uploadModel.save(this.uploadModel.attributes)
            .done(function(photoUrl) {
                // Once the image is saved add it as an item to the list
                var newPhotoItem = this.model.setPhotoFile(photoUrl, hour)
                this.collection.add(newPhotoItem);
                this.collection.trigger("entry:add", new MFoodEntry(newPhotoItem));
            }.bind(this))
        },

        ////////////////////////
        // Sortable callbacks //
        ////////////////////////
        /**
         * Food item added from elsewhere
         */
        onDragAdd: function(e) {
            var callback = Backbone.$(e.from).hasClass('list-items') ?
                this.onEntryDragIn :
                this.addEntry;
            this.$(e.item).trigger('item:move', [this, callback, e.newIndex]);
        },

        onDragSort: function(e) {
            this.toggleChosen(false);
        },

        onDragEnter: function(e) {
            this.toggleChosen(true);
        },

        onDragLeave: function(e) {
            this.toggleChosen(false);
        },

        onDragEnd: function(e) {
            this.toggleChosen(false);
        },

        ////////////
        // events //
        ////////////
        onEntryAdd: function(model) {
            this.refreshCalories();
        },
        onEntryRemove: function(model, options) {
            this.collection.remove(model, options);
            this.refreshCalories();
        },
        onEntryMove: function(model) {
            this.collection.remove(model, { silent: true });
            this.refreshCalories();
        },

        onEntryDragIn: function(view, entry) {
            var collection = this.collection;
            collection.add(entry, { silent: true });
            collection.trigger('entry:add', entry);
        },

        onAddClick: function() {
            this.collection.trigger('entry:click:add', this, this.options.hour);
        },

        onCollectionChange: function() {
            this.refreshCalories();
        },

        onPhotoClick: function() {
            this.showPhotoModal();
        },

        onPhotoChange: function(confirmed, blob, modal) {
            if (confirmed && blob) {
                this.setPhotoFile(blob, this.collection.hour);

                this.setPhotoPreview(blob);
            }
        }
        
    }));

    return VFoodEntryList;

});

